/**
 * Boopr Pet Health — adapter pentru pet-health-widget
 * Modular: nu modifică boopr-pet-account.js.
 * Obține lista completă de pets și o pasează widgetului (cu selector).
 */
(function () {
  "use strict";

  var MAX_WAIT = 10000;
  var CHECK_INTERVAL = 300;
  var injected = false;

  function getAuth() {
    return window.__booprAuth || null;
  }

  // Fetch pets list și returnează array [{id, name, breed, photoUrl}]
  function fetchPets(auth) {
    return fetch("https://api.boopr.ro/accounts/pets", {
      headers: {
        "Content-Type": "application/json",
        "X-Customer-Id":    String(auth.cid),
        "X-Customer-Email": auth.email,
        "X-Customer-Token": auth.token,
      },
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var raw = data.pets || (Array.isArray(data) ? data : []);
        if (raw.length > 0) {
          return raw.map(function (p) {
            return {
              id:          p.id || p._id || null,
              name:        p.name || p.pet_name || "Câine",
              breed:       p.breed || "",
              photoUrl:    p.photo_url || p.photoUrl || null,
              idealWeight: p.weight ? parseFloat(p.weight) : null,
            };
          }).filter(function (p) { return !!p.id; });
        }
        // Fallback: single pet endpoint
        return fetch("https://api.boopr.ro/accounts/pet-profile", {
          headers: {
            "Content-Type": "application/json",
            "X-Customer-Id":    String(auth.cid),
            "X-Customer-Email": auth.email,
            "X-Customer-Token": auth.token,
          },
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var id = d.id || d._id;
            if (!id) return [];
            return [{
              id:       id,
              name:     d.name || d.pet_name || "Câine",
              breed:    d.breed || "",
              photoUrl: d.photo_url || d.photoUrl || null,
            }];
          });
      });
  }

  function injectHealthTab(auth, pets) {
    if (injected) return;
    if (!pets || pets.length === 0) return;

    var nav = document.getElementById("bpet-nav");
    if (!nav) return;
    if (nav.querySelector('[data-tab="health"]')) return;
    if (!window.PetHealth) return;

    injected = true;

    // ── Buton în sidebar ─────────────────────────────────────────────────
    var li = document.createElement("li");
    var btn = document.createElement("button");
    btn.setAttribute("data-tab", "health");

    var icon = document.createElement("span");
    icon.className = "bpet-nav-icon";

    // Folosim același format ca celelalte butoane: <img class="bpet-nav-img">
    // URL-ul SVG-ului îl construim din window.theme.assets.base (setat în theme.liquid)
    var iconImg = document.createElement("img");
    iconImg.className = "bpet-nav-img";
    iconImg.alt = "Sănătate";
    iconImg.src = (window.theme && window.theme.assets && window.theme.assets.base)
      ? window.theme.assets.base + "bpet-icon-sanatate.svg"
      : "";
    icon.appendChild(iconImg);

    var lbl = document.createElement("span");
    lbl.textContent = "Sănătate";

    btn.appendChild(icon);
    btn.appendChild(lbl);
    li.appendChild(btn);

    // Inserăm după li-ul "Câinii mei"
    var petBtn = nav.querySelector('[data-tab="pet"]');
    var insertAfter = petBtn ? petBtn.parentElement : null;
    if (insertAfter && insertAfter.nextSibling) {
      nav.insertBefore(li, insertAfter.nextSibling);
    } else {
      nav.appendChild(li);
    }

    // ── Panel ────────────────────────────────────────────────────────────
    var panel = document.createElement("div");
    panel.id = "bpet-tab-health";
    panel.className = "bpet-panel";

    var widgetRoot = document.createElement("div");
    panel.appendChild(widgetRoot);

    // Inserăm panelul în containerul de panels
    var refPanel = document.getElementById("bpet-tab-pet") || document.getElementById("bpet-tab-home");
    if (refPanel && refPanel.parentElement) {
      refPanel.parentElement.appendChild(panel);
    }

    // ── Fix: deactivate health tab when other tabs clicked ───────────────
    nav.addEventListener("click", function (e) {
      var clickedBtn = e.target.closest("button[data-tab]");
      if (clickedBtn && clickedBtn !== btn) {
        btn.classList.remove("active");
        panel.classList.remove("active");
      }
    });

    // ── Tab click ────────────────────────────────────────────────────────
    btn.addEventListener("click", function () {
      nav.querySelectorAll("button[data-tab]").forEach(function (b) {
        b.classList.remove("active");
      });
      document.querySelectorAll(".bpet-panel").forEach(function (p) {
        p.classList.remove("active");
      });

      btn.classList.add("active");
      panel.classList.add("active");

      if (!widgetRoot._phInit) {
        widgetRoot._phInit = true;
        window.PetHealth.init({
          container: widgetRoot,
          apiBase:   "https://api.boopr.ro/accounts",
          token:     auth,
          pets:      pets,
          theme: {
            primary: "#073056",
            accent:  "#f4b700",
            danger:  "#e81c08",
          },
        });
      }
    });
  }

  // ── Bootstrap ─────────────────────────────────────────────────────────
  function bootstrap() {
    var auth = getAuth();
    if (!auth || !auth.token) return;
    if (!window.PetHealth) return;
    if (!document.getElementById("bpet-nav")) return;

    fetchPets(auth).then(function (pets) {
      if (pets.length > 0) injectHealthTab(auth, pets);
    });
  }

  // ── Contextual help — greutate ideală în formulare de profil ─────────────
  // Injectăm un hint text sub câmpurile de greutate din wizard și edit form.
  // Nu modificăm boopr-pet-account.js — folosim MutationObserver.
  function injectWeightHints() {
    var HINT_CLASS = "bph-weight-hint";
    var HINT_TEXT  = "Introdu greutatea la care câinele tău se simte cel mai bine — greutatea ideală (nu neapărat cea actuală). Aceasta e folosită pentru calculul porțiilor și sugestiile din secțiunea Sănătate.";

    function addHint(inputEl) {
      if (!inputEl) return;
      if (inputEl.parentNode && inputEl.parentNode.querySelector("." + HINT_CLASS)) return;
      var hint = document.createElement("div");
      hint.className = HINT_CLASS;
      hint.style.cssText = "font-size:12px;color:#64748b;margin-top:5px;line-height:1.5;";
      hint.textContent = HINT_TEXT;
      inputEl.parentNode.insertBefore(hint, inputEl.nextSibling);
    }

    function tryAddHints() {
      addHint(document.getElementById("bpet-edit-weight"));
      addHint(document.getElementById("bpet-wiz-weight"));
    }

    tryAddHints();
    // Watch for dynamic form creation (wizard overlay, edit form rendered later)
    var obs = new MutationObserver(tryAddHints);
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // Pornim hints imediat după DOMContentLoaded (sau acum dacă e deja loaded)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", injectWeightHints);
  } else {
    injectWeightHints();
  }

  // Retries — așteptăm PetHealth widget + nav + auth
  var elapsed = 0;
  var timer = setInterval(function () {
    elapsed += CHECK_INTERVAL;
    var ready = window.PetHealth && window.__booprAuth && document.getElementById("bpet-nav");
    if (ready) {
      clearInterval(timer);
      bootstrap();
    } else if (elapsed >= MAX_WAIT) {
      clearInterval(timer);
    }
  }, CHECK_INTERVAL);
})();
